import React from "react";
import LinkExpired from "./views/LinkExpired";
import { ExpiredLinkContextProvider } from "./LinkExpiredView";
import ExpireContent from "../../../constants/contentFile.json";

const LinkExpireView = () => {
  return (
    <ExpiredLinkContextProvider>
      <LinkExpired textContents={ExpireContent.expirePage} />
    </ExpiredLinkContextProvider>
  );
};

export default LinkExpireView;
